var apiClient = require('./apiClient');
var request = apiClient.request;
var requestStream = apiClient.requestStream;

// ── UI Page CRUD ─────────────────────────────────────────────────────────────

function listUiPages(workbookId) {
  var qs = workbookId ? '?workbookId=' + encodeURIComponent(workbookId) : '';
  return request('/ui-page/list' + qs).then(function(result) {
    return result && Array.isArray(result.data) ? result.data : [];
  });
}

function createUiPage(payload) {
  return request('/ui-page', {
    method: 'POST',
    body: payload || {}
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function loadUiPage(pageId) {
  return request('/ui-page/' + encodeURIComponent(pageId)).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function updateUiPage(pageId, patch) {
  return request('/ui-page/' + encodeURIComponent(pageId), {
    method: 'PUT',
    body: patch || {}
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function deleteUiPage(pageId) {
  return request('/ui-page/' + encodeURIComponent(pageId), {
    method: 'DELETE'
  });
}

function publishUiPage(pageId) {
  return request('/ui-page/' + encodeURIComponent(pageId) + '/publish', {
    method: 'POST',
    body: {}
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function unpublishUiPage(pageId) {
  return request('/ui-page/' + encodeURIComponent(pageId) + '/unpublish', {
    method: 'POST',
    body: {}
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function moveUiPage(pageId, target) {
  var t = target || {};
  return request('/ui-page/move', {
    method: 'PUT',
    body: {
      pageId: String(pageId || ''),
      workbookId: String(t.workbookId || ''),
      folderId: String(t.folderId || '')
    }
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

// ── UI Planner helpers ─────────────────────────────────────────────────────

/**
 * Fetch start-node schemas for the given workflow IDs.
 * Returns a Promise<[{ id, name, schema: { params: [...] } }]>.
 */
function fetchWorkflowSchemas(workflowIds) {
  return request('/ui-planner/workflow-schemas', {
    method: 'POST',
    body: { workflowIds: workflowIds || [] }
  }).then(function(result) {
    return result && Array.isArray(result.data) ? result.data : [];
  });
}

// ── UI Planner streams ──────────────────────────────────────────────────────

/**
 * Probe a list of workflow IDs. Returns an abort function.
 * handlers: { onEvent(payload), onClose(), onError(err) }
 */
function streamProbeWorkflows(workflowIds, handlers, opts) {
  var body = { workflowIds: workflowIds || [] };
  if (opts && opts.userInputs) body.userInputs = opts.userInputs;
  return requestStream('/ui-planner/probe-workflows/stream', {
    method: 'POST',
    body: body
  }, handlers || {});
}

/**
 * Stream a planner chat turn. Returns an abort function.
 *
 * `opts.existingHtml`     (optional) — when provided, the planner enters refinement
 *                                       mode and the AI applies changes on top of this HTML.
 * `opts.attachment`       (optional) — a screenshot data URL ("data:image/png;base64,...")
 *                                       to attach to the latest user message for vision.
 * `opts.selectedElement`  (optional) — { snippet } when the user used the
 *                                       "UI select" tool to refine ONE element. Triggers
 *                                       the token-saving single-element response shape.
 *                                       The snippet is the literal substring the server
 *                                       string-replaces inside `existingHtml`.
 */
function streamChatUiPlan(messages, capabilities, handlers, opts) {
  var body = {
    messages: messages || [],
    capabilities: capabilities || []
  };
  if (opts && typeof opts.existingHtml === 'string' && opts.existingHtml) {
    body.existingHtml = opts.existingHtml;
  }
  if (opts && typeof opts.attachment === 'string' && opts.attachment) {
    body.attachment = opts.attachment;
  }
  if (opts && opts.selectedElement && opts.selectedElement.snippet) {
    // Single-element refinement mode. The snippet IS the search key — the
    // server does a literal string replace on existingHtml.
    body.selectedElement = {
      snippet: String(opts.selectedElement.snippet)
    };
  }
  if (opts && opts.chatSessionId) {
    body.chatSessionId = opts.chatSessionId;
  }
  return requestStream('/ui-planner/chat/stream', {
    method: 'POST',
    body: body
  }, handlers || {});
}

// ── Public viewer ────────────────────────────────────────────────────────────

/**
 * Fetch a public UI page by slug. No auth required, but apiClient still
 * sends the token if present (server ignores it for this route).
 */
function loadPublicUiPage(slug) {
  return request('/public/ui-page/' + encodeURIComponent(slug)).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

module.exports = {
  listUiPages: listUiPages,
  createUiPage: createUiPage,
  loadUiPage: loadUiPage,
  updateUiPage: updateUiPage,
  deleteUiPage: deleteUiPage,
  publishUiPage: publishUiPage,
  unpublishUiPage: unpublishUiPage,
  moveUiPage: moveUiPage,
  fetchWorkflowSchemas: fetchWorkflowSchemas,
  streamProbeWorkflows: streamProbeWorkflows,
  streamChatUiPlan: streamChatUiPlan,
  loadPublicUiPage: loadPublicUiPage
};
